import _objectSpread from "@babel/runtime/helpers/objectSpread";
import React from "react";
import styles from "./Url.less";
import cx from "classnames";
export function Url(props) {
  var opts = _objectSpread({}, props, {
    className: cx(styles.link, props.className),
    href: props.href ? props.href : "javascript:void(0)",
    onClick: props.onClick,
    "data-data": props.data
  });

  return React.createElement("a", opts, props.text, props.children);
}